var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1590",
    d: "M16.18 1.16406C15.2522 1.16406 14.5 3.40264 14.5 6.16406H16.18C16.9897 6.16406 17.3945 6.16406 17.6451 5.88452C17.8957 5.60497 17.8521 5.23684 17.7648 4.50057C17.5345 2.55692 16.9119 1.16406 16.18 1.16406Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4993 6.20928V15.0356C14.4993 16.2953 14.4993 16.9251 14.1144 17.1731C13.4853 17.5783 12.5127 16.7286 12.0236 16.4201C11.6195 16.1653 11.4174 16.0378 11.1931 16.0304C10.9508 16.0225 10.7451 16.1447 10.3084 16.4201L8.71601 17.4244C8.28647 17.6953 8.07168 17.8307 7.83268 17.8307C7.59369 17.8307 7.3789 17.6953 6.94935 17.4244L5.35695 16.4201C4.95281 16.1653 4.75073 16.0378 4.52646 16.0304C4.28411 16.0225 4.07845 16.1447 3.64174 16.4201C3.15264 16.7286 2.18008 17.5783 1.55098 17.1731C1.16602 16.9251 1.16602 16.2953 1.16602 15.0356V6.20928C1.16602 3.83094 1.16602 2.64177 1.89825 1.90292C2.63048 1.16406 3.80899 1.16406 6.16602 1.16406H16.166",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.83268 6.16146C6.91221 6.16146 6.16602 6.7211 6.16602 7.41146C6.16602 8.10181 6.91221 8.66146 7.83268 8.66146C8.75316 8.66146 9.49935 9.2211 9.49935 9.91146C9.49935 10.6018 8.75316 11.1615 7.83268 11.1615M7.83268 6.16146C8.55836 6.16146 9.17571 6.50929 9.40451 6.99479M7.83268 6.16146V5.32812M7.83268 11.1615C7.10701 11.1615 6.48965 10.8136 6.26085 10.3281M7.83268 11.1615V11.9948",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.4374d5b6ebd66e56347cdcf91fc710ac.svg";
export { ForwardRef as ReactComponent };